import { Pagination, ConfigProvider } from "antd";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

const TablePagination = ({
  current = 1,
  pageSize = 10,
  total = 50,
  onChange,
  onShowSizeChange,
  pageSizeOptions = ["10", "20", "50", "100"],
}) => {
  const theme = {
    token: {
      colorPrimary: '#52c41a',
    },
  };

  return (
    <div className="flex items-center">
      <div>
        <ConfigProvider theme={theme}>
          <Pagination
            current={current}
            pageSize={pageSize}
            total={total}
            onChange={onChange}
            showSizeChanger={false}
          />
        </ConfigProvider>
      </div>
      {/* Items per page */}
      <div className="flex items-center gap-1">
        <span className="text-gray-400 text-sm hidden sm:block">{<FormattedMessage id="HISTORY.QUANTITY" />}</span>
        <select
          className="border border-gray-300 rounded py-1 w-[60px] text-sm focus:outline-none focus:ring-2 focus:ring-blue-200"
          value={pageSize}
          onChange={(e) =>
            onShowSizeChange && onShowSizeChange(Number(e.target.value))
          }
        >
          {pageSizeOptions.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

TablePagination.propTypes = {
  current: PropTypes.number,
  pageSize: PropTypes.number,
  total: PropTypes.number,
  onChange: PropTypes.func,
  onShowSizeChange: PropTypes.func,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.string),
};

export { TablePagination };
